import { Button } from '@/components/ui/button';
import {
	Drawer,
	DrawerContent,
	DrawerFooter,
	DrawerTitle,
	DrawerDescription,
} from '@/components/ui/drawer';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useGetWishes from '../hooks/useGetWishes';
import { ExternalLink, Pen } from 'lucide-react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent, SheetFooter } from '@/components/ui/sheet';

const WishDetail = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { id_list, id_wish } = useParams();
	const { wishes } = useGetWishes(parseInt(id_list as string));

	if (!id_list) return null;

	const wish = wishes?.find(
		(wish) => wish.id === parseInt(id_wish as string)
	);

	const wishWebsite = wish?.url ? new URL(wish?.url).hostname : '';
	const cleanWebsite = wishWebsite.replace('www.', '');

	const isMobile = window.innerWidth < 640;

	if (!isMobile) {
		return (
			<Sheet
				open={!!id_wish}
				onOpenChange={(open) => !open && navigate(`/list/${id_list}`)}
			>
				<SheetContent className="p-0">
					<ScrollArea className="max-h-[calc(100%-50px)] overflow-auto p-5">
						{wish?.image_key && (
							<img
								src={`${import.meta.env.VITE_API_URL}/image?imageKey=${wish?.image_key}`}
								alt={wish?.name}
								className="mb-4 max-h-[70vh] w-full rounded-md object-cover"
							/>
						)}
						<h1 className="text-lg font-bold">{wish?.name}</h1>
						{!!wish?.price && <p className="">{wish?.price}€</p>}
						{wish?.comment && (
							<p className="mt-4">{wish?.comment}</p>
						)}
						{wish?.url && (
							<Link
								className="mt-4 flex items-center underline"
								to={wish.url}
								target="_blank"
							>
								Voir sur {cleanWebsite}
								<ExternalLink className="ml-2 h-4 w-4" />
							</Link>
						)}
					</ScrollArea>
					<SheetFooter className="px-5">
						<Button
							className="w-full"
							variant="outline"
							onClick={() => navigate(`/list/${id_list}`)}
						>
							{t('common.back')}
						</Button>
						<Button
							variant={'default'}
							className="w-full"
							onClick={() =>
								navigate(`/list/${id_list}/edit/${id_wish}`)
							}
						>
							<Pen className="mr-2 h-4 w-4" /> {t('common.edit')}
						</Button>
					</SheetFooter>
				</SheetContent>
			</Sheet>
		);
	}

	return (
		<Drawer
			open={!!id_wish}
			onOpenChange={(open) => !open && navigate(`/list/${id_list}`)}
		>
			<DrawerContent className="max-h-[95dvh]">
				<DrawerTitle className="hidden">
					{wish?.name || 'Wish'}
				</DrawerTitle>
				<DrawerDescription className="hidden">
					Wish detail
				</DrawerDescription>
				<ScrollArea className="max-h-full overflow-auto p-5">
					{wish?.image_key && (
						<img
							src={`${import.meta.env.VITE_API_URL}/image?imageKey=${wish?.image_key}`}
							alt={wish?.name}
							className="mb-4 max-h-[70vh] w-full rounded-md object-cover"
						/>
					)}
					<h1 className="text-lg font-bold">{wish?.name}</h1>

					{!!wish?.price && <p className="">{wish?.price}€</p>}
					{wish?.comment && <p className="mt-4">{wish?.comment}</p>}
					{wish?.url && (
						<Link
							className="mt-4 flex items-center underline"
							to={wish.url}
							target="_blank"
						>
							Voir sur {cleanWebsite}
							<ExternalLink className="ml-2 h-4 w-4" />
						</Link>
					)}
				</ScrollArea>
				<DrawerFooter>
					<Button
						variant={'default'}
						className="w-full"
						onClick={() =>
							navigate(`/list/${id_list}/edit/${id_wish}`)
						}
					>
						<Pen className="mr-2 h-4 w-4" /> {t('common.edit')}
					</Button>
					<Button
						className="w-full"
						variant="outline"
						onClick={() => navigate(`/list/${id_list}`)}
					>
						{t('common.back')}
					</Button>
				</DrawerFooter>
			</DrawerContent>
		</Drawer>
	);
};

export default WishDetail;
